import styled, { css } from 'styled-components';

export const ColoredPrice = styled.span`
${({ negative }) => negative && css`color: red`}
`;
